/**
 * Calculate the number of days between two dates
 */
export const calculateDaysBetween = (startDate) => {
  const start = new Date(startDate);
  const now = new Date();
  const diffTime = Math.abs(now - start);
  return Math.floor(diffTime / (1000 * 60 * 60 * 24));
};

/**
 * Calculate years, months, and days breakdown
 */
export const calculateTimeUnits = (startDate) => {
  const start = new Date(startDate);
  const now = new Date();

  const diff = now - start;

  const totalDays = Math.floor(diff / (1000 * 60 * 60 * 24));

  const years = Math.floor(totalDays / 365);
  const months = Math.floor((totalDays % 365) / 30);
  const days = (totalDays % 365) % 30;

  return { years, months, days };
};

/**
 * Get upcoming anniversaries sorted by date
 */
export const getUpcomingAnniversaries = (anniversaries, limit = 500) => {
  const now = new Date();
  
  return anniversaries
    .map(ann => {
      const annDate = new Date(ann.date);
      const thisYear = new Date(now.getFullYear(), annDate.getMonth(), annDate.getDate());
      const nextYear = new Date(now.getFullYear() + 1, annDate.getMonth(), annDate.getDate());
      const upcoming = thisYear >= now ? thisYear : nextYear;
      const daysUntil = Math.ceil((upcoming - now) / (1000 * 60 * 60 * 24));
      
      return { ...ann, daysUntil, upcoming };
    })
    .sort((a, b) => a.daysUntil - b.daysUntil)
    .slice(0, limit);
};

/**
 * Format days until text
 */
export const formatDaysUntil = (daysUntil) => {
  if (daysUntil === 0) return 'Today!';
  if (daysUntil === 1) return 'Tomorrow';
  return `In ${daysUntil} days`;
};